import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { usePlaybookExtractions } from '@/composables/usePlaybook';

export interface PlaybookChatMessage {
  content: string;
  role: 'user' | 'assistant';
}

export const usePlaybookStore = defineStore('playbook', () => {
  const {
    data: extractions,
    isLoading: isLoadingExtractions,
    error: extractionsError,
  } = usePlaybookExtractions();

  const chatMessages = ref<PlaybookChatMessage[]>([]);

  const clearChat = () => {
    chatMessages.value = [];
  };

  const totalExtractions = computed(() => extractions.value?.length ?? 0);

  const completedCount = computed(
    () => extractions.value?.filter((e) => e.status === 'complete').length ?? 0,
  );

  const activeCount = computed(
    () => extractions.value?.filter((e) => !['complete', 'failed'].includes(e.status)).length ?? 0,
  );

  const failedCount = computed(
    () => extractions.value?.filter((e) => e.status === 'failed').length ?? 0,
  );

  const isBuilding = computed(() => activeCount.value > 0);

  return {
    extractions,
    isLoadingExtractions,
    extractionsError,
    totalExtractions,
    completedCount,
    activeCount,
    failedCount,
    isBuilding,
    chatMessages,
    clearChat,
  };
});
